import {BllinkLogger} from "../utils/bllink_loggers";
import * as Sentry from "@sentry/react";
import {constants} from "../constants/constants";
const gae = constants.GoogleAnalytics.Events


/**
 * @param {string} categoryName
 * @param {string} eventName
 * @param {string|number} value
 * @param {string} labelName
 * */
async function GAEvent(categoryName, eventName, value, labelName){
    try {
        let payload = {
            event: eventName
        }
        // to make sure we have some value
        value = value ?? 1;
        window.dataLayer = window.dataLayer || [];
        if (eventName === gae.purchase){
            payload.ecommerce =  value;
        }else {
            // value is currently ignore . need to split to 3 cases. money, count and string values
            // in ga -> admin -> Data Display -> Custom definitions -> Custom dimensions
            // will probably need to split 2 different labels because count is done automatically
            // amount - in purchase event is a duplicate of purchase value - send it anyway as event_money_amount
            // string - send it as event_string_value ?
            // considering them can be done in explore-> report -> free form -> dimensions (https://analytics.google.com/analytics/web/#/analysis/p402334044/edit/Ja1JD2LKSPyzbKoJ5se4cw)
            // and also add it to tag manager under  GA4 Param Settings https://tagmanager.google.com/?hl=en#/container/accounts/6002101020/containers/32537426/workspaces/10/variables
            if (isNaN(value)) {
                payload.event_value_string =  value;
            }else{
                if (value !== 1) { // an actual amount
                    payload.event_value_amount = value;
                }
            }

            payload.event_label =  labelName;
            payload.event_category =  categoryName;
        }
        window.dataLayer.push(payload);
    } catch (e) {
        Sentry.captureMessage('Unable track event, check payload', 'error');
    }
}

BllinkLogger.info(`initialized google analytics`);

export {
    GAEvent
}
